import * as React from 'react';
import AuthFooter from './auth-footer.component';
import { M_LOGO } from '../navigation/Constants';

type AuthLayoutWidth = 'narrow' | 'wide';

type Props = {
  readonly width?: AuthLayoutWidth
  readonly isReLogin: boolean
  readonly fromEmailVerification: boolean
};

type States = {};

class AuthLayoutComponent extends React.Component<Props, States> {

  render() {
    return (
      <div
        className="row justify-content-center align-items-center"
        style={this.props.isReLogin || this.props.fromEmailVerification ? null : {height: '100vh'}}
      >
        <div className="col-12 text-center">
          <div
            className="center ba b--black-10 animated fadeIn"
            style={ {
              /* TODO: do not use 'px'. Use 'rem' instead */
              width: (this.props.width === 'wide') ? '750px' : '350px',
              backgroundColor: '#43464e'
            }}
          >
            {this.props.isReLogin ? null :
              <img src={M_LOGO} width="150px" style={{ paddingTop: '20px', paddingBottom: '20px' }}/>}
            <hr className="ma0 b--black-10" />
            <div className="pa3">
            {this.props.children}
              <AuthFooter />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AuthLayoutComponent;


// WEBPACK FOOTER //
// ./src/auth/auth-layout.component.tsx